import { connect } from 'react-redux';

import {
  getFooterData,
  getIsFooterLoading,
  getTaxonomyLevel,
} from 'redux/modules/taxonomy/selectors';

import SiteFooter from './SiteFooter';

export default connect(state => ({
  data: getFooterData(state),
}))(SiteFooter);
